import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { MatSelect } from '@angular/material/select';

@Component({
  selector: 'app-select-all-option',
  templateUrl: './select-all-option.component.html',
  styleUrls: ['./select-all-option.component.scss'],
})
export class SelectAllOptionComponent {
  @Input({ required: true }) matSelect!: MatSelect;
  @Input({ required: true }) allValues: unknown[] = [];

  get areAllSelected(): boolean {
    const selected = this.getSelectedValues();
    return this.allValues.length > 0 && selected.length === this.allValues.length;
  }

  get isIndeterminate(): boolean {
    const selected = this.getSelectedValues();
    return selected.length > 0 && selected.length < this.allValues.length;
  }

  toggle(event: MouseEvent): void {
    event.stopPropagation();
    event.preventDefault();

    const control = this.matSelect.ngControl?.control;
    control?.setValue(this.areAllSelected ? [] : [...this.allValues]);
  }

  private getSelectedValues(): unknown[] {
    const v = this.matSelect.ngControl?.control?.value;
    return Array.isArray(v) ? v : [];
  }
}
